import React from 'react';
import CollapsibleSection from './components/CollapsibleSection';

function NewsList({ news }) {
  return (
    <CollapsibleSection title="Latest News">
      {news && news.length > 0 ? (
        news.map((item, idx) => (
          <div className="news-item" key={idx}>
            <h3><a href={item.link} target="_blank" rel="noopener noreferrer">{item.title}</a></h3>
            <p className="text-muted">{item.source} - {item.date}</p>
            <p>{item.snippet || ''}</p>
          </div>
        ))
      ) : (
        <p>No news found</p>
      )}
    </CollapsibleSection>
  );
}

export default NewsList;
